// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"d9ea04b7","52":"855dc29d","63":"8ba96e3a","86":"f85ad2b3","384":"e8e84a71","499":"c81fd724","521":"e570b9af","549":"e8daa31f","629":"6d20a37c","717":"0f3bffb8","787":"269bfc66","980":"7c734578"}[chunkId] + ".chunk.js";
};